// Auto-generated at build time by scripts/generate-version.js
// Do not edit manually. This file is gitignored.
export const appVersion = {
  version: '0.0.0',
  commit: '094bf97',
  branch: 'main',
} as const;

export type AppVersion = typeof appVersion;
